// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import "./plugins/plotlyPlugin";
import router from "./router";
import axios from "axios";
import Highcharts from "highcharts";
import VueCookie from "vue-cookie";
import VueSession from "vue-session";
import { store } from "./vuex/store";
import { VTree, VSelectTree } from "vue-tree-halower";
import "../node_modules/ag-grid/dist/styles/ag-grid.css";
import "../node_modules/ag-grid/dist/styles/ag-theme-balham.css";
import * as VueWindow from "@hscmap/vue-window";
// import IdleVue from 'idle-vue'

import { LicenseManager } from "ag-grid-enterprise/main";
import { KhronosTextureContainer } from "babylonjs";
LicenseManager.setLicenseKey(
  "MiraeWeb_Inc_on_behalf_of_Alian_Corporation_MultiApp_1Devs22_June_2019__MTU2MTE1ODAwMDAwMA==9d3322567cc376cea23ef5681f4afe1b"
);
// import VueWebsocket from 'vue-websocket'

// axios.defaults.baseURL = 'http://localhost:8080/sop'
axios.defaults.baseURL = "/its";
// axios.defaults.timeout = 5000
axios.defaults.timeout = 10000;
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.withCredentials = true;

let isAuthRedirecting = false;
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err && err.response ? err.response.status : null;

    if ((status === 401) && !isAuthRedirecting) {
      isAuthRedirecting = true;
      localStorage.setItem("authExpiredMessage", "세션이 만료되어 다시 로그인해 주세요.");

      try {
        try {
          const ws = store && store.state ? store.state.webSocket : null;
          if (ws && ws.readyState === WebSocket.OPEN) {
            ws.close();
          }
        } catch (e) {}

        store.commit("setUserInfo");

        window.location.replace("#/login");
      } finally {
        setTimeout(() => {
          isAuthRedirecting = false;
        }, 1000);
      }
    }

    return Promise.reject(err);
  }
);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});

Vue.use(BootstrapVue);
Vue.use(VTree);
Vue.use(VSelectTree);
Vue.use(VueCookie);
Vue.use(VueSession);
Vue.use(VueWindow);
Vue.prototype.$http = axios;
// Vue.use(VueWebsocket, 'ws://localhost:8080/sop-ws')
// const eventsHub = new Vue()
// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   idleTime: 60000 * 30
// })
var EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: function () {
      return EventBus;
    },
  },
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
  created() {
    /** 30분동안 접속이 없으면 로그인 세션을 삭제 후 로그인 페이지로 돌아가기 위한 코드 - kyj */
    /** 페이지의 DOM이 로드 되었을 경우 발생하는 이벤트 이며, 발생 시 로컬스토리지에 저장되었던 닫힌 시간을 갖고와 현재 시간과 비교해 어느정도 시간이 경과했는지 확인한다.(30분이 경과 시 로그인 세션을 삭제 후 로그인 페이지로 돌아간다.) -kyj */
    document.addEventListener("DOMContentLoaded", (event) => {
      let isReset = true;
      let startItsReloadTime = localStorage.getItem("startItsReloadTime");

      if (startItsReloadTime) {
        let differItsReloadTime = new Date().getTime() - startItsReloadTime;

        if (differItsReloadTime < 1000 * 60 * 30) {
          isReset = false;
        }
      }

      if (isReset) {
        try {
          const ws = store && store.state ? store.state.webSocket : null;
          if (ws) {
            ws.onclose = null;
            ws.close();
          }
        } catch (e) {}
        store.commit("setWebSocket", null);
        store.commit("setUserInfo", {
          loginYn: false,
          id: null,
          name: null,
          auth: null,
        });
        this.$router.push("/login");
      }
    });
    /** 페이지의 DOM이 로드 되었을 경우 발생하는 이벤트 이며, 발생 시 로컬스토리지에 저장되었던 닫힌 시간을 갖고와 현재 시간과 비교해 어느정도 시간이 경과했는지 확인한다.(30분이 경과 시 로그인 세션을 삭제 후 로그인 페이지로 돌아간다.) -kyj */

    /** 창이 닫히거나 새로고침 했을 경우 발생하는 이벤트 이며, 발생 시 로컬스토리지에 현재 시간을 저장한다. -kyj */
    window.onbeforeunload = (event) => {
      localStorage.setItem("startItsReloadTime", new Date().getTime());
      // return ''
      return null;
    };
    /** 창이 닫히거나 새로고침 했을 경우 발생하는 이벤트 이며, 발생 시 로컬스토리지에 현재 시간을 저장한다. -kyj */
    /** 30분동안 접속이 없으면 로그인 세션을 삭제 후 로그인 페이지로 돌아가기 위한 코드 - kyj */
  },
  onIdle() {
    // console.log(this.$store.state.userInfo.id)
    // 임시 주석처리
    // console.log('로그아웃처리')
    /* if (this.$route.path !== '/login') {
      if (this.$store.state.userInfo.authority !== 'SC') {
        axios.post('/user/logout', {input: {'user_id': this.$store.state.userInfo.id}})
        // console.log('현재 로그인 사용자 : ' + this.$store.state.userInfo.id)
        this.$router.push({name: 'Login'})
      }
    } */
  },
});



// WEBPACK FOOTER //
// ./src/main.js